export const initializeFadeAnimation = () => {
	const allFadeUps = document.querySelectorAll('.js-fade-up');
	const windowHeight = window.screen.height;
	
	const fadeInit = () => {
		if (allFadeUps?.length) {
			allFadeUps.forEach(fadeUp => {
				const scrollTop = window.pageYOffset;
				const offsetTop = fadeUp.offsetTop;
				const dist = offsetTop - windowHeight*0.8;
				
				if (scrollTop >= dist) {
					fadeUp.classList.add("show");
					setTimeout(() => {
						fadeUp.classList.remove("js-fade-up");
					}, 500);
				}
			});
		}
	};

	fadeInit();

	window.addEventListener("scroll", () => {
		fadeInit();
	});
};
